<div class="submitButtons">
    <p-button [outlined]="true" (click)="addRule()" label="Add Rule" icon="pi pi-plus" />
    <p-button *ngIf="rules.length > 0" (click)="submitRules()" label="Submit Rules" icon="pi pi-check" />
</div>

<div class="settingsContainer">
    <div class="rulesEditor">
        <div *ngFor="let rule of rules.slice().reverse(); let i = index" class="rulesContainer">
            <h4 (click)="toggleExpand(rule)" class="rulesContainer__header">
                <span class="rulesContainer__dot"></span>
                <span class="rulesContainer__title">
                    Rule {{ rules.length - i }} - {{ rule.capType }}
                </span>

                <span class="rulesContainer__right">
                    <span class="rulesContainer__status" [class.actives]="rule.active" [class.inactives]="!rule.active">
                        {{ rule.active ? 'Active' : 'Inactive' }}
                    </span>
                    <span class="rulesContainer__expand" [class.expanded]="rule.isExpanded">
                        <i class="pi pi-chevron-down"></i>
                    </span>
                </span>
            </h4>

            <div class="ruleContainer" [class.hidden]="!rule.isExpanded">
                <div class="ruleContainer__content">
                    <!-- Left side: Descriptions -->
                    <div class="ruleContainer__descriptions">
                        <!-- Cap Section -->
                        <div class="descriptionGroup">
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Cap Type</label>
                                <p class="text-small-roman">Select whether this is a hard or soft
                                    cap</p>
                            </div>
                            <div class="descriptionItem" *ngIf="rule.capType === 'hard'">
                                <label class="text-caption-strong-bold">Cap Percentage</label>
                                <p class="text-small-roman">The maximum fixed percentage cap for price increase</p>
                            </div>
                            <div class="descriptionItem" *ngIf="rule.capType === 'soft'">
                                <label class="text-caption-strong-bold">Cap Percentage Range</label>
                                <p class="text-small-roman">The range for limiting the price percentage increase in soft cap rules
                                </p>
                            </div>
                        </div>

                        <!-- Business Section -->
                        <div class="descriptionGroup">
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Business</label>
                                <p class="text-small-roman">Select a business unit this rule applies to, or leave
                                    empty for all</p>
                            </div>
                        </div>

                        <!-- Country Section -->
                        <div class="descriptionGroup">
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Country</label>
                                <p class="text-small-roman">Select a specific country this rule applies to, or leave
                                    empty for all countries</p>
                            </div>
                        </div>

                        <!-- Industry Vertical & Customer Section -->
                        <div class="descriptionGroup">
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Category</label>
                                <p class="text-small-roman">Select a category to filter customers, or leave empty for all</p>
                            </div>
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Subcategory</label>
                                <p class="text-small-roman">Select a subcategory to further filter customers, or leave empty for all</p>
                            </div>
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Customers</label>
                                <p class="text-small-roman">Select specific customers this rule applies to, or leave
                                    empty for all customers</p>
                            </div>
                        </div>

                        <!-- Price Band Section -->
                        <div class="descriptionGroup">
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Price Band</label>
                                <p class="text-small-roman">Select a price band: &lt;1,000 (0-999), &lt;10,000
                                    (1,000-9,999), or 10,000+</p>
                            </div>
                        </div>

                        <!-- Rule Evaluation Section -->
                        <div class="descriptionGroup">
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Threshold Percentage</label>
                                <p class="text-small-roman">Apply this cap only when the algorithm decides the price
                                    increase exceeds this percentage</p>
                            </div>
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Priority</label>
                                <p class="text-small-roman">Lower numbers have higher priority. Rules are evaluated in
                                    priority order</p>
                            </div>
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Minimum Margin Threshold</label>
                                <p class="text-small-roman">The minimum profit margin percentage required for this rule
                                    to apply</p>
                            </div>
                            <div class="descriptionItem">
                                <label class="text-caption-strong-bold">Annualized Cap (%)</label>
                                <p class="text-small-roman">Maximum annual price increase percentage (e.g. 8 for 8%/year). Leave empty for no annualized cap</p>
                            </div>
                        </div>
                    </div>

                    <!-- Right side: Inputs -->
                    <div class="ruleContainer__inputs">
                        <!-- Cap Configuration -->
                        <div class="inputGroup">
                            <p-dropdown class="inputs" [options]="['hard', 'soft']" [(ngModel)]="rule.capType"
                                placeholder="Select cap type" [disabled]="!rule.isEditing" />
                        </div>
                        <div class="inputGroup" *ngIf="rule.capType === 'hard'">
                            <p-inputNumber class="inputs" type="number" [(ngModel)]="rule.capPct"
                                placeholder="Cap Percentage" [disabled]="!rule.isEditing" />
                        </div>
                        <div class="inputGroup inputItem--range" *ngIf="rule.capType === 'soft'">
                            <div class="inputItem__rangeInputs">
                                <p-inputNumber class="inputs inputs--range" type="number"
                                    [(ngModel)]="rule.capPctRange[0]" placeholder="Min" [disabled]="!rule.isEditing" />
                                <span class="inputItem__separator">-</span>
                                <p-inputNumber class="inputs inputs--range" type="number"
                                    [(ngModel)]="rule.capPctRange[1]" placeholder="Max" [disabled]="!rule.isEditing" />
                            </div>
                        </div>

                        <div class="dividerLine"></div>

                        <!-- Business -->
                        <div class="inputGroup">
                            <p-dropdown class="inputs" [options]="businessOptions" [(ngModel)]="rule.business"
                                [disabled]="!rule.isEditing" placeholder="Select Business" [showClear]="true">
                            </p-dropdown>
                        </div>

                        <div class="dividerLine"></div>

                        <!-- Country -->
                        <div class="inputGroup">
                            <p-dropdown class="inputs" [options]="countryOptions" [(ngModel)]="rule.country"
                                [disabled]="!rule.isEditing" placeholder="Select Country" [showClear]="true" [filter]="true">
                            </p-dropdown>
                        </div>

                        <div class="dividerLine"></div>

                        <!-- Industry Vertical & Customers -->
                        <div class="inputGroup">
                            <p-dropdown class="inputs" [options]="vertical1Options" [(ngModel)]="rule.vertical1"
                                [disabled]="!rule.isEditing" placeholder="Select Category" [showClear]="true" [filter]="true" />
                        </div>
                        <div class="inputGroup">
                            <p-dropdown class="inputs" [options]="vertical2Options" [(ngModel)]="rule.vertical2"
                                [disabled]="!rule.isEditing" placeholder="Select Subcategory" [showClear]="true" [filter]="true" />
                        </div>
                        <div class="inputGroup">
                            <p-multiSelect class="inputs" [options]="customers" [(ngModel)]="rule.customers"
                                [disabled]="!rule.isEditing" placeholder="Select Customers" optionLabel="name"
                                [virtualScroll]="true" [virtualScrollItemSize]="34"
                                [panelStyle]="{ 'max-height': '300px', 'min-width': '550px' }" />
                        </div>

                        <div class="dividerLine"></div>

                        <!-- Price Band -->
                        <div class="inputGroup">
                            <p-dropdown class="inputs" [options]="priceBandOptions" [(ngModel)]="rule.priceBand"
                                [disabled]="!rule.isEditing" placeholder="Select Price Band" [showClear]="true">
                            </p-dropdown>
                        </div>

                        <div class="dividerLine"></div>

                        <!-- Rule Evaluation Settings -->
                        <div class="inputGroup">
                            <p-inputNumber class="inputs" type="number" [(ngModel)]="rule.thresholdPct"
                                placeholder="Threshold Percentage" [disabled]="!rule.isEditing" />
                        </div>
                        <div class="inputGroup">
                            <p-inputNumber class="inputs" type="number" [(ngModel)]="rule.priority"
                                placeholder="Priority" [disabled]="!rule.isEditing" />
                        </div>
                        <div class="inputGroup">
                            <p-inputNumber class="inputs" type="number" [(ngModel)]="rule.minimumMarginThreshold"
                                [disabled]="!rule.isEditing" placeholder="Minimum Margin Threshold (%)">
                            </p-inputNumber>
                        </div>
                        <div class="inputGroup">
                            <p-inputNumber class="inputs" type="number" [(ngModel)]="rule.annualizedCapPct"
                                [disabled]="!rule.isEditing" placeholder="Annualized Cap (%)">
                            </p-inputNumber>
                        </div>
                    </div>
                </div>

                <div class="ruleContainer__footer">
                    <div class="ruleContainer__buttons">
                        <p-button (click)="toggleEdit(rule)" [icon]="rule.isEditing ? 'pi pi-check' : 'pi pi-pencil'"
                            [label]="rule.isEditing ? 'Save' : 'Edit'" size="small">
                        </p-button>
                        <p-button (click)="removeRule(i)" label="Remove" icon="pi pi-times" size="small" />
                        <p-checkbox [(ngModel)]="rule.active" [binary]="true" label="Active"
                            (onChange)="submitRules()" />
                    </div>
                </div>
            </div>
            <hr />
        </div>
    </div>

    <div class="rulesPriority">
        <h3>Rules by Priority</h3>
        <div *ngIf="rules.length === 0" class="emptyState">
            <p>No rules configured</p>
        </div>
        <div *ngIf="rules.length > 0" class="priorityWaterfall">
            <div *ngFor="let rule of sortedRules; let i = index" class="priorityItem" [class.inactive]="!rule.active">
                <div class="priorityItem__header">
                    <span class="priorityItem__priority">{{ rule.priority }}</span>
                    <span class="priorityItem__title">
                        {{ rule.capType | uppercase }} Cap
                    </span>
                    <span class="priorityItem__status" [class.active]="rule.active">
                        {{ rule.active ? 'ACTIVE' : 'INACTIVE' }}
                    </span>
                </div>
                <div class="priorityItem__details">
                    <div class="priorityItem__detail">
                        <span class="label">Threshold:</span>
                        <span class="value">{{ rule.thresholdPct }}%</span>
                    </div>
                    <div class="priorityItem__detail">
                        <span class="label">Customers:</span>
                        <span class="value">{{ rule.customers.length > 0 ? rule.customers.length + ' customers' : 'All'
                            }}</span>
                    </div>
                    <div class="priorityItem__detail" *ngIf="rule.vertical1">
                        <span class="label">Category:</span>
                        <span class="value">{{ rule.vertical1 }}</span>
                    </div>
                    <div class="priorityItem__detail" *ngIf="rule.vertical2">
                        <span class="label">Subcategory:</span>
                        <span class="value">{{ rule.vertical2 }}</span>
                    </div>
                    <div class="priorityItem__detail" *ngIf="rule.capType === 'hard'">
                        <span class="label">Cap:</span>
                        <span class="value">{{ rule.capPct }}%</span>
                    </div>
                    <div class="priorityItem__detail" *ngIf="rule.capType === 'soft'">
                        <span class="label">Cap Range:</span>
                        <span class="value">{{ rule.capPctRange[0] }}% - {{ rule.capPctRange[1] }}%</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>